<template>
<app-wrapper :standalone="true">
  <lead-wizard :type="type"></lead-wizard>
</app-wrapper>
</template>

<script>
import AppWrapper from "../AppWrapper";
import LeadWizard from "./LeadWizard";

export default {
  name: "LeadWizardStandaloneApp",

  props: [
    "type",
  ],

  components: {
    AppWrapper,
    LeadWizard
  }
};
</script>
